import classes from './CodeBlock.module.css';
import { CopyButton } from './CopyButton';

export interface CodeBlockProps {
  code: string;
  copy?: boolean;
  /** Wrap long lines instead of scrolling sideways. */
  wrap?: boolean;
}

export function CodeBlock({ code, copy, wrap }: CodeBlockProps) {
  const cls = [classes.code, copy && classes.withCopy, wrap && classes.wrapLines]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes.wrap}>
      {copy && (
        <div className={classes.bar}>
          <CopyButton text={code} className={classes.copy} />
        </div>
      )}
      <pre className={cls}>
        <code>{code}</code>
      </pre>
    </div>
  );
}
